var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailNotificationIcon = function SvgFailNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6.49 2.077-5.005 8.186c-.21.357-.212.795-.004 1.153.208.357.594.58 1.014.584h10.01c.42-.005.806-.227 1.014-.584a1.138 1.138 0 0 0-.004-1.153L8.51 2.077A1.187 1.187 0 0 0 7.5 1.52c-.413 0-.796.21-1.01.557Z",
    stroke: "#601311",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.053v2.316",
    stroke: "#601311",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.263c.326 0 .591-.259.591-.579a.585.585 0 0 0-.59-.579c-.327 0-.592.26-.592.58 0 .32.265.578.591.578Z",
    fill: "#601311"
  })));
};
export { SvgFailNotificationIcon as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.48955 2.07691L1.48455 10.2632C1.27456 10.6195 1.27331 11.0582 1.48125 11.4156C1.6892 11.7731 2.07511 11.9955 2.495 12.0001H12.505C12.9249 11.9955 13.3108 11.7731 13.5187 11.4156C13.7267 11.0582 13.7254 10.6195 13.5155 10.2632L8.51046 2.07691C8.29621 1.73086 7.9131 1.51953 7.5 1.51953C7.08691 1.51953 6.70379 1.73086 6.48955 2.07691Z' stroke='%23601311' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M7.5 5.05273V7.36852' stroke='%23601311' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.50009 10.2634C7.82644 10.2634 8.091 10.0042 8.091 9.68442C8.091 9.36467 7.82644 9.10547 7.50009 9.10547C7.17374 9.10547 6.90918 9.36467 6.90918 9.68442C6.90918 10.0042 7.17374 10.2634 7.50009 10.2634Z' fill='%23601311'/%3E %3C/svg%3E";